import { render } from "./pre-order-message.vue?vue&type=template&id=50f1d01f"
import script from "./pre-order-message.vue?vue&type=script&lang=js"
export * from "./pre-order-message.vue?vue&type=script&lang=js"

import "./pre-order-message.vue?vue&type=style&index=0&id=50f1d01f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__